import { render, staticRenderFns } from "./ApplicationInformation.vue?vue&type=template&id=b5bc16d6&scoped=true"
import script from "./ApplicationInformation.vue?vue&type=script&lang=js"
export * from "./ApplicationInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bc16d6",
  null
  
)

export default component.exports